export default class OrderCardModel {
    constructor() {
        this.id = undefined;
        this.draft = false;
        this.template = false;
        this.name = undefined;
        this.cardKind = undefined;
        this.vehicleRequired = false;
        this.driverRequired = false;
        this.odometerRequired = false;
        this.mpkRequired = false;
        this.monthlyAmountLimit = undefined;
        this.dailyVisitLimit = undefined;
        this.fuelQuantityLimit = {};
        this.fuelAmountLimit = {};
        this.notFuelAmountLimit = {};
        this.serviceAmountLimit = {};
        this.cardList = [];
        this.petrols = [];
        this.services = [];
        this.products = [];
        this.multienergeticSelected = false;
        this.regularCardSelected = false;
        this.electro = false;
    }

    static assign(from, to, t) {
        if (from) {
            to.id = from.id;
            to.draft = from.draft;
            to.template = from.template;
            to.name = from.name;
            to.cardKind = from.cardKind;
            to.odometerRequired = from.odometerRequired;
            to.driverRequired = from.driverRequired;
            to.vehicleRequired = from.vehicleRequired;
            to.mpkRequired = from.mpkRequired;
            to.monthlyAmountLimit = from.monthlyAmountLimit;
            to.dailyVisitLimit = from.dailyVisitLimit;
            to.fuelQuantityLimit = from.fuelQuantityLimit;
            to.fuelAmountLimit = from.fuelAmountLimit;
            to.notFuelAmountLimit = from.notFuelAmountLimit;
            to.serviceAmountLimit = from.serviceAmountLimit;
            to.cardList = from.cardList ? from.cardList : [];
            to.petrols = from.petrols ? from.petrols : [];
            to.services = from.services ? from.services : [];
            to.products = from.products ? from.products : [];
            to.multienergeticSelected = from.cardList.length >0 ? from.cardList[0].electromobility : from.electro ;
            to.regularCardSelected = from.cardList.length >0 ? !!!(from.cardList[0].electromobility) : from.electro;
            to.electro = from.electro;
         } else {
            to = new OrderCardModel();
        }
    }

    static copy(from, t) {
        const to = new OrderCardModel();
        OrderCardModel.assign(from, to, t);
        return to;
    }
}
